const Graph = require('./BaseGraph')

module.exports = class StatsGraph extends Graph 
{
    constructor(apiDomain, path="learnearn")
    {
        super(apiDomain, path)
    }

    // Get Points Query
    IQPointsQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getIQ ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }
    
    // Get Badges Query
    badgesEarnedQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getBadgesEarned ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // Get Reviews Given Query
    reviewsGivenQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getReviewsGiven ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // Get Articles Query
    articlesReadQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getArticlesRead ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }
    
    // Get Video Watch Query
    videoWatchQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getVideoWatched ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // Get audio listened Query
    audioListenedQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getAudioListened ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // Get files downloaded Query
    filesDownloadedQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getFilesDownloaded ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // Get Recipe Used Query
    recipeUsedQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getRecipeUsed ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // Get Point this Month Query
    newPointThisMonthQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getPointThisMonth ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // Get Point this Year query
    newPointThisYearQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getPointThisYear ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // Average points query
    averagePointsPerMonthQuery(fields, params=null)
    {
        if (params)
            return { type: 'activityStats', query: this.queryString('activityStats', fields, params) }

        return { type: 'activityStats', query: `query getAveragePointsPerMonth ($contact_id: Int, $type: String!) {
            activityStats(contact_id: $contact_id, type: $type)
            ${this.queryFields(fields)}
        }` }
    }

    // monthly stats query
    monthlyStatsQuery(fields, params=null)
    {
        if (params)
            return { type: 'monthlyStats', query: this.queryString('monthlyStats', fields, params) }

        return { type: 'monthlyStats', query: `query getMonthlyStats ($contact_id: Int, $year: Int) {
            monthlyStats(contact_id: $contact_id, year: $year)
            ${this.queryFields(fields)}
        }` }
    }

    // Content Viewed Query
    contentViewedQuery(fields, params=null)
    {
        if (params)
            return { type: 'contentViewed', query: this.queryString('contentViewed', fields, params) }

        return { type: 'contentViewed', query: `query getContentViewed ($contact_id: Int) {
            contentViewed(contact_id: $contact_id)
            ${this.queryFields(fields)}
        }` }
    }

}